import { Button } from '@cian/ui-kit/button';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { TThunkDispatch } from 'shared/types/redux';

import { IButtonWithAnalyticEvent } from './types';

export const ButtonWithAnalyticEvent = <T,>(props: IButtonWithAnalyticEvent<T>): React.JSX.Element => {
  const { onClick, trackAnalyticEvent, customView: CustomButton = Button, analyticsParams, ...otherProps } = props;
  const dispatch = useDispatch<TThunkDispatch>();

  const handleClick = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
    event => {
      if (trackAnalyticEvent) {
        dispatch(trackAnalyticEvent(analyticsParams));
      }

      if (onClick) {
        onClick(event);
      }
    },
    [analyticsParams, dispatch, onClick, trackAnalyticEvent],
  );

  return <CustomButton {...otherProps} onClick={handleClick} />;
};

ButtonWithAnalyticEvent.displayName = 'ButtonWithAnalyticEvent';
